/**
 * @generated SignedSource<<07203bc5210383b66f44c8843fd06e29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectHealthStatusSection_project$data = {
  readonly id: string;
  readonly stage: {
    readonly id: string;
    readonly name: string | null;
    readonly profile: PROJECT_STATUS | null;
  } | null;
  readonly projectHealth: {
    readonly suggestedStatusRag: string | null;
  } | null;
  readonly currentProjectStatus: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectStatus_projectStatus">;
  } | null;
  readonly projectStatuses: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly year: number | null;
        readonly month: number | null;
        readonly day: number | null;
        readonly hour: number | null;
        readonly minute: number | null;
        readonly second: number | null;
        readonly " $fragmentSpreads": FragmentRefs<"ProjectStatus_projectStatus">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ProjectHealthStatusSection_project";
};
export type ProjectHealthStatusSection_project$key = {
  readonly " $data"?: ProjectHealthStatusSection_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectHealthStatusSection_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ProjectStatus_projectStatus"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "projectStatuses"
        ]
      }
    ]
  },
  "name": "ProjectHealthStatusSection_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "stage",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profile",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectHealth",
      "kind": "LinkedField",
      "name": "projectHealth",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "suggestedStatusRag",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectStatus",
      "kind": "LinkedField",
      "name": "currentProjectStatus",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "projectStatuses",
      "args": null,
      "concreteType": "ProjectStatusTypeConnection",
      "kind": "LinkedField",
      "name": "__Project_projectStatuses_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectStatusTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectStatus",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "year",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "month",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "day",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hour",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minute",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "second",
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};
})();

(node as any).hash = "2ce291e7ff4f9d5ed98426b8f1d32a60";

export default node;
